import React, { useState, useEffect, useCallback } from "react";
import Classes from "./AppointmentTabs.module.css";
import DropDown from "./StatusDropDown/DropDown";
import UpdateStatusPopup from "../../../../../../../../GlobalComponents/UpdateStatusPopup/UpdateStatusPopup";
import { AnimatePresence } from "framer-motion";
import { useSelector } from "react-redux";
import backend from "../../../../../../../../../api";

const DB_TO_UI = {
  completed: "Completed",
  upcoming: "Upcoming",
  cancelled: "Cancelled",
  on_the_way: "On the way",
  delayed: "Delayed",
};

export default function AppointmentDetails({ booking, refresh }) {
  const [open, setOpen] = useState(false);
  const { token, user } = useSelector((s) => s?.auth || {});
  const [loading, setLoading] = useState(false);
  const [invoice, setInvoice] = useState([]);

  // ---- helpers / derived values (safe even if booking is null) ----
  const amount = Number(booking?.pricing?.total || 0).toLocaleString(undefined, {
    style: "currency",
    currency: booking?.pricing?.currency || "USD",
  });
  const serviceDate = booking?.appointment?.date || "-";
  const timeSlot = booking?.appointment?.timeSlot || "-";
  const statusUi = DB_TO_UI[booking?.status] || "Upcoming";


  // ---- load invoices (memoized fn, used by effect) ----
  const load = useCallback(async () => {
    if (!booking?._id) return; // nothing to load yet
    setLoading(true);
    try {
      const { data } = await backend.get(
        `/api/invoices/by-booking?bookingId=${booking._id}`,
        { headers: token ? { Authorization: `Bearer ${token}` } : undefined }
      );
      setInvoice(Array.isArray(data?.items) ? data.items : []);
    } catch (e) {
      console.error("load invoices error", e);
      setInvoice([]);
    } finally {
      setLoading(false);
    }
  }, [booking?._id, token]);

  // ---- run loader whenever booking id changes ----
  useEffect(() => {
    load();
  }, [load]);

  console.log('invoicce', invoice)
  // ---- status submit ----
  const submitStatus = async ({ status, message, etaAt }) => {
    try {
      const resp = await backend.put(
        `/api/bookings/${booking._id}/status`,
        { status, message, etaAt, byUserId: user?._id },
        { headers: token ? { Authorization: `Bearer ${token}` } : undefined }
      );
      if (resp?.data?.ok) {
        setOpen(false);
        refresh?.();
      } else {
        alert(resp?.data?.error || "Failed to update status");
      }
    } catch (e) {
      alert(e?.response?.data?.error || e.message);
    }
  };

  // You can still early-return for no booking, but AFTER hooks are declared.
  if (!booking) return null;

  // Optional debug
  // console.log("invoice", invoice, "loading:", loading);

  return (
    <>
      <section className={Classes.panel}>
        <h3 className={Classes.title}>Appointment Details</h3>

        <div className={Classes.row}>
          <p className={Classes.label}>Service Date</p>
          <p className={`${Classes.value} ${Classes.muted}`}>
            {serviceDate} • {timeSlot}
          </p>
        </div>

        <div className={Classes.row}>
          <p className={Classes.label}>Service Type</p>
          <p className={`${Classes.value} ${Classes.muted}`}>Fuel Delivery</p>
        </div>

        <div className={Classes.row}>
          <p className={Classes.label}>Amount</p>
          <p className={`${Classes.value} ${Classes.muted}`}>{amount}</p>
        </div>

        <div className={Classes.row}>
          <p className={Classes.label}>Payment Status</p>
          <DropDown isDropDown={false} selectedValue={invoice[0]?.status??'Invoice deleted'} options={["Paid", "Late"]} />
        </div>

        <div className={Classes.row}>
          <p className={Classes.label}>Status</p>
          <span onClick={() => setOpen(true)}>
            <DropDown
              selectedValue={statusUi}
              options={["Completed", "Upcoming", "Cancelled", "On the way", "Delayed"]}
              isDropDown={true}
            />
          </span>
        </div>
      </section>

      <AnimatePresence>
        {open && (
          <UpdateStatusPopup
            closePopup={() => setOpen(false)}
            submitPopup={() => {}}
            booking={booking}
            onSubmit={submitStatus}
            initialStatus={statusUi}
          />
        )}
      </AnimatePresence>
    </>
  );
}
